export const STORAGE_KEY_UID = 'usr:uid';
export const STORAGE_KEY_TOKEN = 'usr:acc';
export const STORAGE_KEY_REFRESH = 'usr:ref';
export const STORAGE_KEY_API = 'usr:api';
export const COOKIE_KEY_API_BASE_URL = 'hh_api_base_url'; // all cookie keys are lowercase
export const STORAGE_KEY_ACTIVE_FACILITY = 'usr:active-facility';
